var _path, _path2, _path3, _polygon, _polygon2, _rect, _polygon3, _rect2, _polygon4, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,10v23.333h23.333V10H10z M26.667,26.667h-10v-10h10V26.667z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10,66.666V90h23.333V66.666H10z M26.667,83.334h-10v-10h10V83.334z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.667,10v23.333H90V10H66.667z M83.333,26.667h-10v-10h10V26.667z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "40,10 40,16.667 53.333,16.667 53.333,33.333 60,33.333 60,10 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "46.667,83.334 46.667,66.666 40,66.666 40,90 53.333,90 53.333,83.334 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83.333,
    y: 40,
    width: 6.667,
    height: 13.334
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "76.667,40 53.333,40 53.333,53.334 60,53.334 60,46.667 76.667,46.667 "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.333,
    y: 53.334,
    width: 23.334,
    height: 6.666
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "40,23.333 40,40 10,40 10,60 16.667,60 16.667,46.667 46.667,46.667 46.667,23.333 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.333,56.666c-9.205,0-16.666,7.461-16.666,16.668C56.667,82.539,64.128,90,73.333,90C82.539,90,90,82.539,90,73.334  C90,64.127,82.539,56.666,73.333,56.666z M72.155,80.699l-8.838-8.84l3.535-3.535l5.303,5.303l7.659-7.66l3.535,3.535L72.155,80.699  z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.ab45f462ca373520329ba3695fbdb7a2.svg";
export { ForwardRef as ReactComponent };